import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import { formatDate } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column";
import CareerForm from "./form/index.form";

type Props = {};

const index: React.FC<Props> = ({}) => {
  const pathname = usePathname();
  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();
  let {
    data: fetchData,
    refetch,
    isPending,
    error,
  } = useListData<QueryData<any>>({
    endpoint: endpoint["career"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      is_show: searchParams.get("is_show") || "",
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "order",
      status: searchParams.get("expiration_status") || "",
      experience_level: searchParams.get("career-exprience") || "",
    },
  });
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  const { mutate } = usePostData();
  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["career"],
        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (fetchData) {
            const newItems = fetchData.data.results.map((item) =>
              item.slug === id ? { ...item, is_show: state } : item
            );

            fetchData.data.results = newItems;
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };
  const columns = ColumnList({ refetch, toggleActiveStatus });

  return (
    <>
      <TableCard
        bulkActions
        rows={fetchData?.data?.results ?? []}
        isPending={isPending}
        endpoint={endpoint["career"]}
        count={fetchData?.data?.count ?? 10}
        refetch={refetch}
        table_content={{
          mode: "default",
          type: pathname,
        }}
        columns={columns}
        inject_ui_table_actions={
          <FilterPopover
            filters={[
              {
                label: "Experience Level",
                endpointValue: "career-exprience",
                format: {
                  key: "level_name",
                  value: "id",
                },
              },
              {
                label: "Expiration Status",
                searchKey: "expiration_status",
                radio: true,
                defaultOptions: [
                  {
                    label: "Expired",
                    value: "expired",
                  },
                  {
                    label: "Expiring Soon",
                    value: "expiring_soon",
                  },
                  {
                    label: "Not Expired",
                    value: "not_expired",
                  },
                ],
              },
              {
                label: "Visibility",
                radio: true,
                searchKey: "is_show",
                defaultOptions: [
                  {
                    label: "Shown",
                    value: "true",
                  },
                  {
                    label: "Hidden",
                    value: "false",
                  },
                ],
              },
            ]}
            title="Filter"
            triggerText="Filter"
          />
        }
        formId={pathname}
        form={<CareerForm />}
        sortableFilter={{
          search: search,
          experience_level: searchParams.get("career-exprience") || "",
          ordering: searchParams.get("ordering") || "order",
          status: searchParams.get("expiration_status") || "",
          is_show: searchParams.get("is_show") || "",
        }}
        grid={
          <GeneralCard
            showCheck
            isChecked={true}
            type={"career"}
            onDelete={() => {}}
            onEdit={() => {}}
            onToggleStatus={(id: string, state: boolean) =>
              toggleActiveStatus(id, state)
            }
          />
        }
      />
    </>
  );
};

export default index;
